import React, { useEffect, useState } from 'react';
import { Body, SubmitButton, FormCadastro, Input, InputNumber, PageHeader, Spin, View, Field, GroupField } from '@components';
import { getVersao, postVersao, putVersao, reset } from '@ducks/conectoresVersoes';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import App from '@app';

export default function Detalhes() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { nrBuild } = useParams();
  const [form] = FormCadastro.useForm();
  const edicao = nrBuild !== '-1';
  const [loaded, setLoaded] = useState(false);

  const versao = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('versao'));
  const loadingVersao = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('loadingVersao'));
  const successVersao = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('successVersao'));
  const successPut = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('successPutVersao'));
  const successPost = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('successPostVersao'));

  useEffect(() => {
    form.setFieldsValue({
      urlDownload: ' https://gitlab.com/api/v4/projects/teammove%2Fconector-update/jobs/{JOB_CONECTOR_UPDATE}/artifacts',
    });
  }, []);

  useEffect(() => {
    if (!loadingVersao && !loaded && edicao) {
      setLoaded(true);
      dispatch(getVersao(nrBuild));
    }
  }, [loadingVersao]);

  useEffect(() => {
    if (successPut || successPost) {
      dispatch(reset());
      history.goBack();
    }
  }, [successPut, successPost]);

  useEffect(() => {
    if (versao && edicao) {
      form.setFieldsValue(versao);
    }
  }, [successVersao]);

  function handleSubmit(data) {
    if (edicao) {
      data['nrBuild'] = nrBuild;
      dispatch(putVersao(data));
    } else {
      dispatch(postVersao(data));
    }
  }

  return (
    <App>
      <Body>
        <PageHeader title="Versão" onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            {loadingVersao ? (
              <Spin />
            ) : (
              <View>
                <GroupField>
                  <Field label="Versão" name="versao" rules={[{ required: true, message: 'Informe a versão' }]}>
                    <Input autoFocus />
                  </Field>
                  <Field label="Job Conector" name="jobConector" rules={[{ required: true, message: 'Informe o job do conector' }]}>
                    <InputNumber />
                  </Field>
                </GroupField>
                <GroupField>
                  <Field
                    label="URL de Atualização"
                    name="urlDownload"
                    rules={[{ required: true, message: 'Informe a URL de atualização' }]}
                  >
                    <Input />
                  </Field>
                </GroupField>
                <GroupField>
                  <Field label="Descrição" name="ds" rules={[{ required: true, message: 'Informe a descrição' }]}>
                    <Input.TextArea />
                  </Field>
                </GroupField>
                <SubmitButton type="success" htmlType="submit" block>
                  Salvar
                </SubmitButton>
              </View>
            )}
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
